module.exports = __webpack_public_path__ + "img/1440.3982ee3b.jpg";